import { render, staticRenderFns } from "./PagamentoAprovarComJustificativa.vue?vue&type=template&id=bb933b52"
import script from "./PagamentoAprovarComJustificativa.vue?vue&type=script&lang=js"
export * from "./PagamentoAprovarComJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports